import { default as AxiosIns } from "axios";
import Cookies from "js-cookie";

const axios = AxiosIns.create();

axios.interceptors.request.use(
	config => {
		const shop = window?.location?.pathname?.split("/")[1];
		const token = Cookies.get("authToken", { path: `/${shop}` });

		const authorization = config?.headers?.Authorization;

		if (token && !authorization) {
			config.headers.Authorization = token;
		}

		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

export default axios;
